// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
// ICONS
import { CgSpinner } from 'react-icons/cg';

const Button = (props) => {

    const sizes = {
        lg: "--lg",
        md: "--md",
        sm: "--sm",
        xs: "--xs"
    }

    return (
        <>
            {
                props.type ?
                    <button
                        onClick={props.onClick ? props.onClick : () => { }}
                        className={`button${props.size ? sizes[props.size] : ""} ${props.className ? props.className : ""} ${props.uppercaseText ? "uppercase" : ""}`}
                        style={props.style}
                        disabled={props.disabled}
                        type={props.type}
                    >
                        {
                            props.iconLeft ? props.iconLeft : <></>
                        }
                        {
                            props.loading ?
                                <CgSpinner className="loading-indicator rotating" size={25} /> : props.text
                        }
                    </button>
                    :
                    <Link
                        to={props.to ? props.to : "#"}
                        target={props.target}
                        onClick={props.onClick ? props.onClick : () => { }}
                        className={`button${props.size ? sizes[props.size] : ""} ${props.className ? props.className : ""} ${props.uppercaseText ? "uppercase" : ""}`}
                        style={props.style}
                        disabled={props.disabled}
                    >
                        {
                            props.iconLeft ? props.iconLeft : <></>
                        }
                        {
                            props.loading ?
                                <CgSpinner className="loading-indicator rotating" size={25} /> : props.text
                        }
                    </Link>
            }
        </>
    );
}

export default Button;